import classNames from "classnames";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import imagesLoaded from "imagesloaded";
import isMobile from "ismobilejs";

import "./scroll.scss";

const lerp = (a: number, b: number, n: number) => (1 - n) * a + n * b;

declare global {
  interface Window {
    rcScrollY: number;
  }
}

interface scrollProps {
  className?: string;
}

const Scroll: React.FC<scrollProps> = (props) => {
  const useDefaultScroll = useRef<boolean>(isMobile().any);
  //
  const [contentHeight, setContentHeight] = useState(0);
  //
  const scrollableRef = useRef<HTMLDivElement>(null);
  //
  const docScroll = useRef<number>(0);
  const current = useRef<number>(0);
  const scrollToRender = useRef<number>(0);
  const speedTarget = useRef<number>(0);
  const ease = 0.1;
  const aFrame = useRef<any>();

  useLayoutEffect(() => {
    const handleResize = () => {
      setContentHeight(scrollableRef.current?.scrollHeight || 0);
    };
    // handle content loading
    if (scrollableRef.current) {
      imagesLoaded(scrollableRef.current, () => {
        handleResize();
      });
    }
    //
    useDefaultScroll.current &&
      document.body.classList.add("use-default-scroll");
    //
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const setPosition = () => {
      if (
        Math.round(scrollToRender.current) !== Math.round(current.current) ||
        scrollToRender.current < 10
      ) {
        if (scrollableRef.current) {
          scrollableRef.current.style.transform = `translate3d(0,${
            -1 * scrollToRender.current
          }px,0)`;
        }
      }
    };

    const getScroll = () => {
      docScroll.current =
        window.pageYOffset || document.documentElement.scrollTop;
      return docScroll.current;
    };

    const render = () => {
      if (document.body.classList.contains("is-fixed")) {
        aFrame.current = requestAnimationFrame(render);
        return false;
      }
      const speed =
        Math.min(Math.abs(current.current - scrollToRender.current), 200) / 200;
      speedTarget.current += (speed - speedTarget.current) * 0.2;

      current.current = getScroll();
      let renderCurrent = lerp(scrollToRender.current, current.current, ease);
      renderCurrent = Math.floor(renderCurrent * 100000) / 100000;
      renderCurrent < 0 && (renderCurrent = 0);
      scrollToRender.current = renderCurrent;

      renderCurrent < 1
        ? document.body.classList.remove("is-scrolled")
        : document.body.classList.add("is-scrolled");

      !useDefaultScroll.current && setPosition();
      // props.appScrollProps.current = scrollToRender.current;
      window.rcScrollY = scrollToRender.current;
      // document.documentElement.style.setProperty(
      //   "--scroll",
      //   `${scrollToRender.current}`
      // );
      aFrame.current = requestAnimationFrame(render);
    };

    aFrame.current = requestAnimationFrame(render);
    return () => cancelAnimationFrame(aFrame.current);
  }, []);

  // location change
  // useEffect(() => {
  //   return history.listen((location) => {
  //     window.scrollTo(0,0);
  //     scrollToRender.current = 0;
  //     window.rcScrollY = scrollToRender.current;
  //   });
  // }, [history]);

  return (
    <div
      className={classNames("scroll", props.className, {
        "use-default": useDefaultScroll.current,
      })}
      style={{ height: `${contentHeight}px` }}
    >
      <div className="scroll__scrollable" ref={scrollableRef}>
        {props.children}
      </div>
    </div>
  );
};

export default Scroll;
